<template>
  <div class="custom-page-element">
    <div class="uk-flex uk-flex-center" v-if="!loading && data != null">
      <div class="uk-width-1-2@m uk-width-1-1">
        <div class="section-card" v-for="(item, i) of data.sections" :key="i">
          <div
            class="uk-text-center section-header"
            :style="{
              backgroundColor: item.header.background_color,
              color: item.header.text_color,
            }"
            v-if="item.header != null"
          >
            <div>
              <h4 :style="{ color: item.header.text_color }">
                {{ item.header.title }}
              </h4>
              <span :style="{ color: item.header.text_color }">{{
                item.header.subtitle
              }}</span>
            </div>
          </div>
          <img
            class="uk-flex-center uk-flex"
            alt="Smart TV LED Roomi"
            :src="item.image"
          />
        </div>
        <div class="uk-flex-center uk-flex uk-margin-bottom uk-margin-top">
          <a
            :href="data.purchase_link"
            target="_blank"
            class="button-buy-now"
            >Pesan Sekarang</a
          >
        </div>
        <hr />
        <div class="marketplace-section">
          <div class="uk-flex-center uk-flex">
            <h3
              class="uk-text-center uk-text-bold uk-margin-left uk-margin-right"
            >
              BISA DIPESAN DI MARKETPLACE
            </h3>
          </div>
          <div class="uk-flex-center uk-flex uk-margin-bottom" v-for="(item, i) of data.marketplaces" :key="i">
            <a
              :href="item.link"
              target="_blank"
              class="uk-button uk-button-default uk-block button-marketplace"
              style="display: block"
            >
              <img
                :src="item.marketplace.image"
                style="width: 120px"
                :alt="item.marketplace.name"
              />
            </a>
          </div>
        </div>
        <div class="custom-footer">
          <div class="uk-flex-center uk-flex">Roomi</div>
          <div class="uk-flex-center uk-flex">
            Copyright © {{ new Date().getFullYear() }} |
            <a
              href="https://roomi.co.id/"
              target="_blank"
              style="margin-left: 3px"
              >roomi.co.id</a
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 100vh">
      <div class="uk-container" style="height: 100%">
        <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 100%">
          <div uk-spinner></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      data: null,
    };
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product-page/${this.$route.params.url}`
        )
        .then((res) => {
          if (res.status == 200) {
            this.loading = false;
            const data = res.data;
            this.data = data.data;
            this.setSeo();
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          this.$router.push("/not-found");
        });
    },
    setSeo() {
      // let titlePage = "Smart TV LED Roomi";
      // const siteDescription = "Smart TV LED Roomi";
      let titlePage = this.data.title + " Roomi"
      let siteDescription = this.data.description
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
  },
};
</script>

<style scoped>
html {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2 !important;
  -webkit-text-size-adjust: 100%;
  background: #ffffff;
  color: #403f41;
}
h4 {
  line-height: 1.2 !important;
}
.section-header {
  padding: 15px 10px;
}
.section-header h4 {
  margin-bottom: 10px !important;
  font-size: 20px;
  font-weight: bold;
}
.section-header span {
  font-size: 14px !important;
  /* font-weight: 300 !important; */
}
.custom-footer {
  background: #403f41;
  padding: 15px;
  color: white;
}
.custom-footer a {
  color: white !important;
  font-weight: bold;
}
.marketplace-section {
  margin: 40px 0px !important;
}
.button-marketplace {
  padding: 7px 30px;
  border-radius: 7px;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
.button-marketplace:active {
  top: 2px;
}
.button-buy-now {
  border: none;
  font-size: inherit;
  cursor: pointer;
  display: inline-block;
  margin: 30px 20px;
  text-transform: uppercase;
  font-weight: 700;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  padding: 20px 30px 20px 30px;
  background: #2ecc71;
  color: #fff;
  border-radius: 7px;
}
.button-buy-now:hover {
  background: #27ae60;
}
.button-buy-now:active {
  background: #27ae60;
  top: 2px;
}
.button-buy-now::after {
  content: "";
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
.button-buy-now::before {
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
  background: rgba(0, 0, 0, 0.15);
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}
</style>